/* eslint-disable react-hooks/exhaustive-deps */
import Table from "rc-table";
import { mobileColumns, desktopColumns, summaryColumns } from "./utils";
import { isDesktop } from "utils";
// import { data } from "utils/userBase";
import { CompanyType } from "types/CompanyTypes";
import { SharesByCompanyType } from "types/SharesTypes";
import { Tooltip } from "react-tooltip";
import "./ClientsTable.scss";
import { useGetTransaction } from "hooks/transactions";

interface ClientsTableType {
  company: CompanyType | null;
  setEditTransaction: (company: SharesByCompanyType) => void;
}

const ClientsTable = ({ company, setEditTransaction }: ClientsTableType) => {
  const shareId = company?.shareId
    ? String(company.shareId)
    : company?.shares?.[0]?.id
    ? String(company?.shares[0].id)
    : "";

  const { data: transactionData } = useGetTransaction(shareId);

  return (
    <div className="companies-table clients-table">
      <Tooltip
        place="top"
        className="tooltip tooltip--noShadow"
        id="company-tooltip"
      />
      <Table
        rowKey="id"
        className="companies-table"
        data={transactionData}
        columns={
          isDesktop()
            ? desktopColumns({ company, setEditTransaction })
            : mobileColumns({ company })
        }
      />

      {isDesktop() && !!transactionData && !!company && (
        <Table
          className="clients-table__summary"
          rowKey="id"
          data={[transactionData?.[0]]}
          columns={summaryColumns(company)}
        />
      )}
    </div>
  );
};

export default ClientsTable;
